import {h} from 'preact'
import PropTypes from 'prop-types'
import cn from 'classnames'

import './grid.scss'

const sizes = ['xs', 'sm', 'md', 'lg']

const columns = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]

const offsets = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

Row.propTypes = {
  children: PropTypes.any.isRequired,
  el: PropTypes.string,
  className: PropTypes.string,
  center: PropTypes.oneOf(sizes),
  end: PropTypes.oneOf(sizes),
}

export function Row({children, el: Element = 'div', className, center, end}) {
  return (
    <Element
      class={cn(className, 'Row', {
        [`Row_center_${center}`]: center,
        [`Row_end_${end}`]: end,
      })}
    >
      {children}
    </Element>
  )
}

Col.propTypes = {
  children: PropTypes.any.isRequired,
  el: PropTypes.string,
  className: PropTypes.string,
  auto: PropTypes.bool,
  xsOffset: PropTypes.oneOf(offsets),
  xs: PropTypes.oneOf(columns),
  smOffset: PropTypes.oneOf(offsets),
  sm: PropTypes.oneOf(columns),
  mdOffset: PropTypes.oneOf(offsets),
  md: PropTypes.oneOf(columns),
  lgOffset: PropTypes.oneOf(offsets),
  lg: PropTypes.oneOf(columns),
}

export function Col({
  children,
  el: Element = 'div',
  className,
  auto,
  xsOffset,
  xs,
  smOffset,
  sm,
  mdOffset,
  md,
  lgOffset,
  lg,
}) {
  return (
    <Element
      class={cn(className, 'Col', {
        Col_auto: auto,
        [`Col_xs_offset_${xsOffset}`]: xsOffset,
        [`Col_xs_${xs}`]: xs,
        [`Col_sm_offset_${smOffset}`]: smOffset,
        [`Col_sm_${sm}`]: sm,
        [`Col_md_offset_${mdOffset}`]: mdOffset,
        [`Col_md_${md}`]: md,
        [`Col_lg_offset_${lgOffset}`]: lgOffset,
        [`Col_lg_${lg}`]: lg,
      })}
    >
      {children}
    </Element>
  )
}
